module.exports = __webpack_public_path__ + "img/personal-info.7ba6a214.svg";